<!--
 * @Author: ZS
 * @Date: 2020-06-18 16:24:41
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-17 11:15:39
 * @Description: file content
-->
<template>
  <div class="myBusiness">
    <h3 class="myTit clearfix">
      <span>审批工作</span>
      <ul class="clearfix noselect">
        <li :class="{active:titIndex === 0}" @click="titChange(0)">待办</li>
        <li :class="{active:titIndex === 1}" @click="titChange(1)">待阅</li>
        <li :class="{active:titIndex === 2}" @click="titChange(2)">已办</li>
        <li :class="{active:titIndex === 3}" @click="titChange(3)">已阅</li>
      </ul>
    </h3>
    <!-- 待办表格 -->
    <el-table :data="tableData.data0" border style="width: 100%" v-show="titIndex === 0">
      <el-table-column prop="xuhao" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column label="事项名称" prop="guidelineName">
        <template slot-scope="scope">
          <span>{{scope.row.guidelineName}}</span>
          <el-tag type="success" effect="dark" v-if="scope.row.processstatus == 2">正常</el-tag>
          <el-tag type="warning" effect="dark" v-if="scope.row.processstatus == 3">预警</el-tag>
          <el-tag type="danger" effect="dark" v-if="scope.row.processstatus == 1">超期</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="发起人" width="150" align="center">
      </el-table-column>
      <el-table-column prop="processinstancecreatetime" label="发起时间" width="150" align="center">
      </el-table-column>
      <el-table-column prop="taskName" label="当前节点" width="150" align="center" v-if="titIndex == 0">
      </el-table-column>
      <el-table-column label="操作" align="center" width="130">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class="detailBtn">详情</el-button>
          <!-- <el-button size="mini" type="danger" @click="inquiryOpen(scope.$index, scope.row)" class="advisoryBtn">
            咨询</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 待阅表格 -->
    <el-table :data="tableData.data1" border style="width: 100%" v-show="titIndex === 1">
      <el-table-column prop="xuhao" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column label="标题" prop="messagetitle">
      </el-table-column>
      <el-table-column prop="sendName" label="发送人" width="150" align="center">
      </el-table-column>
      <el-table-column prop="sendtime" label="发送时间" width="150" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="130">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class="detailBtn">详情</el-button>
          <!-- <el-button size="mini" type="danger" @click="inquiryOpen(scope.$index, scope.row)" class="advisoryBtn">
            咨询</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 已办表格 -->
    <el-table :data="tableData.data2" border style="width: 100%" v-show="titIndex === 2">
      <el-table-column prop="xuhao" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column label="事项名称" prop="guidelineName">
        <template slot-scope="scope">
          <span>{{scope.row.guidelineName}}</span>
          <el-tag type="success" effect="dark" v-if="scope.row.processstatus == 2">正常</el-tag>
          <el-tag type="warning" effect="dark" v-if="scope.row.processstatus == 3">预警</el-tag>
          <el-tag type="danger" effect="dark" v-if="scope.row.processstatus == 1">超期</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="发起人" width="150" align="center">
      </el-table-column>
      <el-table-column prop="processinstancecreatetime" label="发起时间" width="150" align="center">
      </el-table-column>
      <el-table-column prop="progressnodeendtime" label="办理时间" width="150" align="center" v-if="titIndex == 2">
      </el-table-column>
      <el-table-column label="操作" align="center" width="130">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class="detailBtn">详情</el-button>
          <!-- <el-button size="mini" type="danger" @click="inquiryOpen(scope.$index, scope.row)" class="advisoryBtn">
            咨询</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 已阅表格 -->
    <el-table :data="tableData.data3" border style="width: 100%" v-show="titIndex === 3">
      <el-table-column prop="xuhao" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column label="标题" prop="messagetitle">
      </el-table-column>
      <el-table-column prop="sendName" label="发送人" width="150" align="center">
      </el-table-column>
      <el-table-column prop="sendtime" label="发送时间" width="150" align="center">
      </el-table-column>
      <el-table-column prop="readtime" label="阅读时间" width="150" align="center" v-if="titIndex == 3">
      </el-table-column>
      <el-table-column label="操作" align="center" width="130">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class="detailBtn">详情</el-button>
          <!-- <el-button size="mini" type="danger" @click="inquiryOpen(scope.$index, scope.row)" class="advisoryBtn">
            咨询</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="block fenyeBox" v-show="titIndex === 0">
      <el-pagination @size-change="handleSizeChange0" @current-change="handleCurrentChange0"
        :current-page="pageNum.num0" :page-sizes="[10, 20, 30, 40]" :page-size="100"
        layout="total, sizes, prev, pager, next, jumper" :total="totalNum.total0">
      </el-pagination>
    </div>
    <div class="block fenyeBox" v-show="titIndex === 1">
      <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
        :current-page="pageNum.num1" :page-sizes="[10, 20, 30, 40]" :page-size="100"
        layout="total, sizes, prev, pager, next, jumper" :total="totalNum.total1">
      </el-pagination>
    </div>
    <div class="block fenyeBox" v-show="titIndex === 2">
      <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
        :current-page="pageNum.num2" :page-sizes="[10, 20, 30, 40]" :page-size="100"
        layout="total, sizes, prev, pager, next, jumper" :total="totalNum.total2">
      </el-pagination>
    </div>
    <div class="block fenyeBox" v-show="titIndex === 3">
      <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
        :current-page="pageNum.num3" :page-sizes="[10, 20, 30, 40]" :page-size="100"
        layout="total, sizes, prev, pager, next, jumper" :total="totalNum.total3">
      </el-pagination>
    </div>
    <el-dialog title="我要咨询" :visible.sync="inquiryVisible">
      <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="inquiryVisible = false">取 消</el-button>
        <el-button type="primary" @click="inquiryVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    props: {
      numChange: {
        type: Function
      }
    },
    data() {
      return {
        tableData: {
          data0: [],
          data1: [],
          data2: [],
          data3: [],
        },
        titIndex: 0,
        inquiryVisible: false,
        textarea: '',
        pageNum: {
          num0: 1,
          num1: 1,
          num2: 1,
          num3: 1,
        },
        pageSize: {
          size0: 10,
          size1: 10,
          size2: 10,
          size3: 10,
        },
        totalNum: {
          total0: 0,
          total1: 0,
          total2: 0,
          total3: 0,
        },
      }
    },
    mounted() {
      this.getDb(0)
    },
    methods: {
      handleEdit(index, row) {
        // console.log(index, row);
        window.open(row.taskUrl)
      },
      inquiryOpen(index, row) {
        console.log(index, row);
        this.inquiryVisible = true
      },
      handleSizeChange0(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize.size0 = val
        this.getDb(0)
      },
      handleCurrentChange0(val) {
        // console.log(`当前页: ${val}`);
        this.pageNum.num0 = val
        this.getDb(0)
      },
      handleSizeChange1(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize.size1 = val
        this.getDyy(0)
      },
      handleCurrentChange1(val) {
        // console.log(`当前页: ${val}`);
        this.pageNum.num1 = val
        this.getDyy(0)
      },
      handleSizeChange2(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize.size2 = val
        this.getDb(1)
      },
      handleCurrentChange2(val) {
        // console.log(`当前页: ${val}`);
        this.pageNum.num2 = val
        this.getDb(1)
      },
      handleSizeChange3(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize.size3 = val
        this.getDyy(1)
      },
      handleCurrentChange3(val) {
        // console.log(`当前页: ${val}`);
        this.pageNum.num3 = val
        this.getDyy(1)
      },
      titChange(idx) {
        this.titIndex = idx
        if (idx === 0) {
          this.getDb(0)
        }
        if (idx === 1) {
          this.getDyy(0)
        }
        if (idx === 2) {
          this.getDb(1)
        }
        if (idx === 3) {
          this.getDyy(1)
        }
      },
      // 获取待办已办
      getDb(type) {
        let sendData
        if (this.titIndex == 0) {
          sendData = qs.stringify({
            pageNum: this.pageNum.num0,
            pageSize: this.pageSize.size0,
            resultType: type,
          })
        } else if (this.titIndex == 2) {
          sendData = qs.stringify({
            pageNum: this.pageNum.num2,
            pageSize: this.pageSize.size1,
            resultType: type,
          })
        }
        this.ywtbRequest('/portal-ywtb/web/process/findWork', sendData).then(res => {
          var data = res.dataList
          for (let i = 0; i < data.length; i++) {
            data[i].xuhao = i + 1
          }
          if (type == 0) {
            this.totalNum.total0 = res.count
            this.tableData.data0 = res.dataList
          }
          if (type == 1) {
            this.tableData.data2 = res.dataList
            this.totalNum.total2 = res.count
          }
          this.numChange(res.count)
        })
      },
      //获取待阅已阅
      getDyy(type) {
        let sendData
        if (this.titIndex == 1) {
          sendData = qs.stringify({
            pageNum: this.pageNum.num1,
            pageSize: this.pageSize.size1,
            resultType: type,
          })
        } else if (this.titIndex == 3) {
          sendData = qs.stringify({
            pageNum: this.pageNum.num3,
            pageSize: this.pageSize.size3,
            resultType: type,
          })
        }
        this.ywtbRequest('/portal-ywtb/web/message/findMessage', sendData).then(res => {
          var data = res.dataList
          for (let i = 0; i < data.length; i++) {
            data[i].xuhao = i + 1
          }
          if (type == 0) {
            this.tableData.data1 = res.dataList
            this.totalNum.total1 = res.count
          }
          if (type == 1) {
            this.tableData.data3 = res.dataList
            this.totalNum.total3 = res.count
          }
          this.numChange(res.count)
        })
      }
    }
  }

</script>

<style scoped>
  .myTit {
    /* line-height: 42px; */
    padding: 30px 0 15px 0;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .myTit>span {
    float: left;
    color: #091B28;
    font-size: 22px;
    font-family: PingFang SC;
  }

  .myTit>ul {
    float: right;
  }

  .myTit>ul>li {
    float: left;
    width: 84px;
    height: 34px;
    background: rgba(53, 139, 247, 0.1);
    color: #687986;
    line-height: 34px;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    cursor: pointer;
  }

  .myTit>ul>li.active {
    background-color: #358BF7;
    color: #fff;
  }

  .detailBtn,
  .advisoryBtn {
    width: 56px;
    height: 27px;
    border-radius: 14px;
    padding: 0;
    text-align: center;
    font-size: 13px;
    color: #fff;
    border: none;
  }

  .detailBtn {
    background: rgba(255, 165, 71, 1);

  }

  .detailBtn:hover, .detailBtn:focus {
    background: rgba(255, 165, 71, 0.8);
    color: #fff;
  }

  .advisoryBtn {
    background: rgba(53, 139, 247, 1);
  }

  .advisoryBtn:hover, .advisoryBtn:focus {
    background: rgba(53, 139, 247, 0.8);
    color: #fff;
  }

  .fenyeBox {
    text-align: center;
    padding-top: 20px;
  }

  .newBg {
    display: inline-block;
    width: 55px;
    height: 23px;
    line-height: 22px;
    background: url(../../../../static/images/newBg.png) no-repeat 0px 0px;
    text-align: center;
    color: #fff;
    margin-left: 6px;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/user/ApprovalWork.vue